// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ecc4b3f4","750":"1e553ec4","803":"a3818674","952":"b5be4c60"}[chunkId] + ".chunk.js";
};